import styles from './index.module.scss';
import { useFm } from '@web3/base-hooks';
import RightArrow from '@/assets/images/bybitsol/right-arrow.svg';
import { Event } from '@/config/track-config';
import { scTrack } from '@web3/base-tracking';
import { MobileCommunity } from './MobileCommunity';
import { appPath } from '@web3/base-utils';

const DesktopCommunity = () => {
  const fm = useFm();

  const onClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    name,
    url
  ) => {
    e.preventDefault();
    scTrack(Event.Web3UserClick, {
      page_name: 'StakingWeb_BBSOLhomepage',
      button_name: `BBSOLhomepage_${name}`,
    });
    window.open(url);
  };

  return (
    <div className={styles.containerWrapper}>
      <div className={styles.container}>
        <div className={styles.left}>
          <p className={styles.join}>Join</p>
          <p className={styles.bybit}>{fm('bybitWeb3')}</p>
          <p className={styles.bbsol}>bbSol</p>
          <p className={styles.community}>{`${fm('join_community')}`}</p>
          <div className={styles.btns}>
            <a
              className={styles.telegram}
              target="_blank"
              href="https://t.me/BybitEnglish"
              onClick={(e) => {
                onClick(e, 'telegram', 'https://t.me/BybitEnglish');
              }}
            >
              <img src={`${appPath}/svg/home/telegram.svg`} alt="telegram" />
              <p>Telegram</p>
            </a>
            <a
              className={styles.twitter}
              target="_blank"
              href="https://twitter.com/Bybit_Web3"
              onClick={(e) => {
                onClick(e, 'twitter', 'https://twitter.com/Bybit_Web3');
              }}
            >
              <img src={`${appPath}/png/bybitsol/twitter.png`} alt="twitter" />
              <p>Twitter</p>
            </a>
          </div>
        </div>
        <div className={styles.right}>
          <p className={styles.build}>{fm('buildWithUs2')}</p>
          <p className={styles.official}>{fm('officialDocumentation')}</p>
          <a
            className={styles.integrate}
            target="_blank"
            href="https://uponly.larksuite.com/share/base/form/shrusiQ3FwkuwGiDcR933kq5lAc"
          >
            <p>{fm('integrateBybitWeb3Wallet')}</p>
            <RightArrow />
          </a>
          <div className={styles.line} />
          <p className={styles.partner}>{fm('partnerWithUs')}</p>
          <p className={styles.collaborate}>{fm('collaborateWithUs')}</p>
          <a
            className={styles.listing}
            target="_blank"
            href="https://uponly.larksuite.com/share/base/form/shrusE6TYZJGVBO9LOCWCICiWvb"
          >
            <p>{fm('listingPartnership')}</p>
            <RightArrow />
          </a>
          <a
            className={styles.dapp}
            target="_blank"
            href="https://uponly.larksuite.com/share/base/form/shrusy12cnDPuKJV2JDimh1qvjb"
          >
            <p>{fm('dAppStoreListing2')}</p>
            <RightArrow />
          </a>
        </div>
      </div>
    </div>
  );
};

export const Community = () => {
  return (
    <>
      <DesktopCommunity />
      <MobileCommunity />
    </>
  );
};
